import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme, useAppStyles } from '../theme';
import { useStore } from '../store';
import toast from 'react-hot-toast';
import { auth } from '../services/api';

export default function LoginScreen() {
  const C = useTheme();
  const styles = useAppStyles();
  const nav = useNavigate();
  const { login } = useStore();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const set = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const submit = async () => {
    if (!form.email || !form.password) return toast.error('Fill all fields');
    setLoading(true);
    try {
      const r = await auth.login(form);
      login(r.user || { email: form.email }, r.token || r.access_token);
      nav('/home');
    } catch (e) { toast.error(e.message); }
    setLoading(false);
  };

  return (
    <div style={{
       background: C.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      backgroundImage: `linear-gradient(160deg, ${C.primary}10 0%, ${C.bg} 60%)`,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <img src="/vgo-logo.png" alt="VGO" style={{width:72,height:72,objectFit:'contain',margin:'0 auto 16px',display:'block',filter:'drop-shadow(0 8px 24px #6366f166)'}} />
          <div style={{ fontSize: 28, fontWeight: 800, color: '#fff', letterSpacing: -0.5 }}>Nexus</div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 4 }}>by VGO Global</div>
        </div>

        {/* Card */}
        <div style={{
          background: C.card, border: `1px solid ${C.border}`,
          borderRadius: 24, padding: '32px 28px',
          boxShadow: '0 24px 64px rgba(0,0,0,0.4)'
        }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#fff', marginBottom: 6 }}>Welcome back</div>
          <div style={{ fontSize: 13, color: C.muted, marginBottom: 28 }}>Sign in to your VGO account</div>

          {/* Email */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, color: C.muted, display: 'block', marginBottom: 8, fontWeight: 600 }}>EMAIL</label>
            <input type="email" placeholder="you@example.com"
              value={form.email} onChange={set('email')}
              onKeyDown={e => e.key === 'Enter' && submit()}
              style={{
                width: '100%', background: C.input, border: `1px solid ${C.inputBorder}`,
                borderRadius: 12, padding: '14px 16px', color: '#fff',
                fontSize: 15, outline: 'none', boxSizing: 'border-box',
                transition: 'border 0.2s'
              }}
              onFocus={e => e.target.style.borderColor = '#6366f1'}
              onBlur={e => e.target.style.borderColor = C.inputBorder}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: C.muted, display: 'block', marginBottom: 8, fontWeight: 600 }}>PASSWORD</label>
            <input type="password" placeholder="••••••••"
              value={form.password} onChange={set('password')}
              onKeyDown={e => e.key === 'Enter' && submit()}
              style={{
                width: '100%', background: C.input, border: `1px solid ${C.inputBorder}`,
                borderRadius: 12, padding: '14px 16px', color: '#fff',
                fontSize: 15, outline: 'none', boxSizing: 'border-box'
              }}
              onFocus={e => e.target.style.borderColor = '#6366f1'}
              onBlur={e => e.target.style.borderColor = C.inputBorder}
            />
          </div>

          {/* Forgot */}
          <div style={{ textAlign: 'right', marginBottom: 24 }}>
            <span onClick={() => nav('/forgot-password')} style={{
              fontSize: 13, color: '#6366f1', cursor: 'pointer', fontWeight: 500
            }}>Forgot password?</span>
          </div>

          {/* Button */}
          <button onClick={submit} disabled={loading} style={{
            width: '100%', padding: '15px',
            background: loading ? C.border : 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            border: 'none', borderRadius: 14, color: '#fff',
            fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
            boxShadow: loading ? 'none' : '0 4px 24px #6366f144'
          }}>{loading ? 'Signing in...' : 'Sign In →'}</button>

          {/* Register link */}
          <div style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: C.muted }}>
            New to VGO?{' '}
            <span onClick={() => nav('/register')} style={{
              color: '#6366f1', cursor: 'pointer', fontWeight: 600
            }}>Create account</span>
          </div>
        </div>
      </div>
    </div>
  );
}
